<template>
  <v-container fluid class="pa-0 ma-0">
    <v-alert color="red" type="error" v-if="!currentArticle">Aucun article trouvé</v-alert>
    <template v-else  >
    <v-img
        alt="Photo d'illustration"
        :src="getFullURL(currentArticle.mediaObjectImage)"
        transition="scale-transition"
        max-height="300px"
    >
      <v-row align="center" justify="center" class="fill-height">
        <h2 class="white--text shadow-1 text-center" style="text-shadow: 0 0 6px black;">{{ currentArticle.titre }}</h2>
      </v-row>
    </v-img>
    <v-row>
      <v-col align-center offset-sm="2" cols="12" sm="8">
        <v-btn :to="{name:'Actu'}" color="blue" dark class="mt-3 ml-3 mb-10"><v-icon class="mr-1">mdi-arrow-left-circle</v-icon> Actualité</v-btn>
        <v-row v-html="currentArticle.contenu" class="article-content"/>
        <v-btn :to="{name:'Actu'}" color="blue" dark class="mt-10 ml-3 mb-10"><v-icon class="mr-1">mdi-arrow-left-circle</v-icon> Actualité</v-btn>
      </v-col>
    </v-row>
    </template>
  </v-container>
</template>

<script>
import ArticleMixin from "../../mixins/ArticleMixin";
import MediaObjectMixin from "../../mixins/MediaObjectMixin";

export default {
  name: "Article",
  mixins: [ArticleMixin, MediaObjectMixin],
  data: () => ({
  }),
  computed: {
    currentArticleIdToLoad() {
      return this.$route.params.articleId ? this.$route.params.articleId : null;
    }
  },
  created() {
    if (this.currentArticleIdToLoad) {
      this.loadArticle(this.currentArticleIdToLoad);
    }
  },
  watch:{
    currentArticleIdToLoad:function (before,after) {
      if(before!= after){
        this.loadArticle(this.currentArticleIdToLoad);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$font: "Roboto", sans-serif;
$font-titre: "Roboto Condensed", sans-serif;
$orange: #f1662c;
$bleu: #18b3e2;

.article-content {
  width: 100%;
  max-width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* Très important pour le contenu injecté via v-html */
.article-content ::v-deep p,
.article-content ::v-deep h1,
.article-content ::v-deep h2,
.article-content ::v-deep h3,
.article-content ::v-deep h4,
.article-content ::v-deep ul,
.article-content ::v-deep ol,
.article-content ::v-deep li,
.article-content ::v-deep div {
  max-width: 100%;
  box-sizing: border-box;
}

/* Corrige le texte qui semble collé/coupé */
.article-content ::v-deep p {
  margin: 0 0 1rem 0;
  padding: 0;
  line-height: 1.7;
  font-size: 1rem;
}

/* Images fluides */
.article-content ::v-deep img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 16px auto;
}

/* Iframes / vidéos */
.article-content ::v-deep iframe,
.article-content ::v-deep video {
  max-width: 100%;
}

/* Si le HTML injecté contient des .row de Vuetify ou bootstrap */
.article-content ::v-deep .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.article-content ::v-deep [class*="col-"] {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (max-width: 600px) {
  .article-content {
    padding: 0 24px;
  }

  .article-content ::v-deep p {
    font-size: 0.98rem;
    line-height: 1.65;
  }
}
</style>
